import { StepState } from '@/enums/step-states';
import { StepType } from '../../../interfaces/enums/step-type';
import IAction from '@/interfaces/actions.interface';
import IStep from '@/interfaces/step.interface';
import store from '@/store';

export default class BaseStep implements IStep {
	public stepType!: StepType;
	public actions: IAction[] = [];
	public icon = '';
	public heading = '';
	public description = '';
	public readyToCompleteText = '';

	public stepState(): StepState {
		let allActionsCompleted = true;

		const hasCompletedStep = this.hasCompletedStep();

		if (hasCompletedStep) {
			return StepState.DONE;
		}

		for (const action of this.actions) {
			if (!action.done()) {
				allActionsCompleted = false;
			}
		}

		if (allActionsCompleted && !hasCompletedStep) {
			return StepState.READY_TO_COMPLETE;
		}

		return StepState.IN_PROGRESS;
	}

	protected hasCompletedStep(): boolean {
		const journeyState = store.getters.getJourneyState();

		if (journeyState?.[this.stepType]?.completed) {
			return true;
		}

		return false;
	}
}
